import UiButton from "@/components/ui/UiButton";
import UiCard from "@/components/ui/UiCard";
import UiDateRange from "@/components/ui/UiDateRange";
import UiDialog from "@/components/ui/UiDialog";
import UiField from "@/components/ui/UiField";
import UiFieldInput from "@/components/ui/UiFieldInput";
import UiFieldRange from "@/components/ui/UiFieldRange";
import UiFieldSelect from "@/components/ui/UiFieldSelect";
import UiFieldTextArea from "@/components/ui/UiFieldTextArea";
import UiFocusLock from "@/components/ui/UiFocusLock";
import UiHeading from "@/components/ui/UiHeading";
import UiInput from "@/components/ui/UiInput";
import UiLoader from "@/components/ui/UiLoader";
import UiOverlayLoader from "@/components/ui/UiOverlayLoader";
import UiPopover from "@/components/ui/UiPopover";
import UiRangeInput from "@/components/ui/UiRangeInput";
import UiSelect from "@/components/ui/UiSelect";
import UiTextArea from "@/components/ui/UiTextArea";
import UiButtonGroup from "@/components/ui/UiButtonGroup";
import UiAccordion from "@/components/ui/UiAccordion";

function install(Vue) {
  Vue.component("ui-button", UiButton);
  Vue.component("ui-card", UiCard);
  Vue.component("ui-date-range", UiDateRange);
  Vue.component("ui-dialog", UiDialog);
  Vue.component("ui-field", UiField);
  Vue.component("ui-field-input", UiFieldInput);
  Vue.component("ui-field-range", UiFieldRange);
  Vue.component("ui-field-select", UiFieldSelect);
  Vue.component("ui-field-text-area", UiFieldTextArea);
  Vue.component("ui-focus-lock", UiFocusLock);
  Vue.component("ui-heading", UiHeading);
  Vue.component("ui-input", UiInput);
  Vue.component("ui-loader", UiLoader);
  Vue.component("ui-overlay-loader", UiOverlayLoader);
  Vue.component("ui-popover", UiPopover);
  Vue.component("ui-range-input", UiRangeInput);
  Vue.component("ui-select", UiSelect);
  Vue.component("ui-text-area", UiTextArea);
  Vue.component("ui-button-group", UiButtonGroup);
  Vue.component("ui-accordion", UiAccordion);
}

export default { install };
